<template>
  <header class="header">
    <h1 class="">用户协议与隐私协议</h1>
  </header>
  <div class="container">
    <div class="agreement">
      <p>    请您务必审慎阅读、充分理解“用户协议”和“隐私政策”各条款，包括但不限于：为了更好的向您提供服务，我们需要收集您的设备标识、操作日志等信息用于分析、优化应用性能。
    您可阅读<router-link to="/user">《用户协议》</router-link>和<router-link to="/privacy">《隐私政策》</router-link>了解详细信息。如果您同意，请点击下面按钮开始接受我们的服务。</p>
<!--      <textarea-->
<!--          class="scrollable-textarea">-->
<!--    </textarea>-->
    </div>
    <div class="buttons">
      <button class="confirm" @click="handleConfirm">确认</button>
      <button class="cancel" @click="handleCancel">取消</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  methods: {
    goToUserComponent() {
      this.$router.push("/user");
    },
    handleConfirm() {
      if (window.nativeHandler) {
        window.nativeHandler.onWebResult(JSON.stringify({ action: 'agreement',  param: 1}, null));
      }
    },
    handleCancel() {
      if (window.nativeHandler) {
        window.nativeHandler.onWebResult(JSON.stringify({ action: 'agreement',  param: 0}, null));
      }
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 10%;
  background-color: #f4f4f9;
  color: white;
  /*align-items: center;*/
  /*justify-content: space-between;*/
  /*padding: 0 0 0 10px;*/
  position: fixed;
  top: 0;
  left: 0;
  /*margin-bottom: 50px;*/
  /*z-index: 1000;*/
}
h1 {
  text-align: center;
  color: #42b983;
}
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f4f4f9;
  color: #333;
  overflow: hidden; /* 确保可以滚动 */
}
::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 */
}
.container {
  max-width: 100%;
  max-height: 100%;
  /*margin: auto;*/
  background: #fff;
  padding: 0px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.agreement {
  height: 140px;
  overflow-y: auto;
  margin: 10px 0;
  padding: 15px;
  border: 1px solid #ddd;
  background-color: #fafafa;
  border-radius: 4px;
  text-align: left;
}
.buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}
button {
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.confirm {
  background-color: #42b983;
  color: white;
  width: 120px;
}
.confirm:hover {
  background-color: #3a9c74;
}
.cancel {
  background-color: #e74c3c;
  color: white;
  width: 120px;
}
.cancel:hover {
  background-color: #c0392b;
}
.return {
  background-color: #cccccc;
  color: white;
  width: 200px;
}
.return:hover {
  background-color: #f4f4f9;
}
pre {
  white-space: pre-wrap; /* 保留格式并自动换行 */
  word-wrap: break-word; /* 长单词强制换行 */
  /*border: 1px solid #ccc; !* 边框便于观察效果 *!*/
  /*padding: 10px;*/
  background-color: #f9f9f9;
  font-size: x-large;
}
</style>
